import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const Field = (props) => (_jsxs("div", { className: `form-group ${props.value ? "" : "text-muted"}`, children: [_jsx("label", { id: `${props.label}-label`, children: props.label }), _jsx("div", { className: "form-control-static", children: props.value })] }));
export default Field;
